import React from "react";
import logoLight from "../../images/logo-light.webp";

const Footer = () => {
  return (
    <footer
      style={{ backgroundColor: "#1b1b1c" }}
      className="footer p-20 bg-base-200 text-base-content"
    >
      <div>
        <img src={logoLight} alt="" />
        <p>
          ACME Industries Ltd.
          <br />
          Providing reliable parts since 1992
        </p>
      </div>
      <div>
        <span className="footer-title">Services</span>
        <a className="link link-hover">Branding</a>
        <a className="link link-hover">Design</a>
        <a className="link link-hover">Marketing</a>
        <a className="link link-hover">Advertisement</a>
      </div>
      <div>
        <span className="footer-title">Company</span>
        <a className="link link-hover">About us</a>
        <a className="link link-hover">Contact</a>
        <a className="link link-hover">Jobs</a>
        <a className="link link-hover">Press kit</a>
      </div>
      <div>
        <span className="footer-title">Legal</span>
        <a className="link link-hover">Terms of use</a>
        <a className="link link-hover">Privacy policy</a>
        <a className="link link-hover">Cookie policy</a>
      </div>
    </footer>
  );
};

export default Footer;
